import { render, staticRenderFns } from "./registerCompany.vue?vue&type=template&id=cb2773f2&scoped=true"
import script from "./registerCompany.vue?vue&type=script&lang=js"
export * from "./registerCompany.vue?vue&type=script&lang=js"
import style0 from "./registerCompany.vue?vue&type=style&index=0&id=cb2773f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2773f2",
  null
  
)

export default component.exports